import { render, staticRenderFns } from "./citizenships-name.vue?vue&type=template&id=e4f3f868&"
import script from "./citizenships-name.vue?vue&type=script&lang=ts&"
export * from "./citizenships-name.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports